export default __webpack_public_path__ + "484f10179d33fa2992d921e710b1ea3a.woff2";